import { IonicPage, ModalController } from 'ionic-angular';
import { Component } from '@angular/core';
import { AppConfig } from '../../../../app/app.config';
import { DailyLogModalPage } from '../../../daily-log/daily-log-modal/daily-log-modal';

/**
 * Generated class for the SafetyEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-consumable-edit',
  templateUrl: 'consumable-edit.html',
})
export class ConsumableEditPage {
  config = AppConfig.settings;

  constructor(public modalController: ModalController) {
  }

  ionViewDidLoad() {
  }

  openDailyLogModal() {
    const dailyLogModal = this.modalController.create(DailyLogModalPage);
    dailyLogModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/consumables/consumable-edit/consumable-edit.ts